/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Checkbox, Text } from '@sonarsource/echoes-react';
import { FormattedMessage } from 'react-intl';
import { useStandardExperienceModeQuery } from '~sq-server-commons/queries/mode';

interface SandboxSettingQualitiesOverrideSectionProps {
  allowOverride: boolean;
  onOverrideChange: (override: boolean) => void;
}

export default function SandboxSettingQualitiesOverrideSection({
  onOverrideChange,
  allowOverride,
}: Readonly<SandboxSettingQualitiesOverrideSectionProps>) {
  const { data: isStandardMode } = useStandardExperienceModeQuery();

  return (
    <>
      <Text as="p" className="sw-my-4" isHighlighted>
        <FormattedMessage id="settings.sandbox_issues.override_admins.title" />
      </Text>
      <Checkbox
        checked={allowOverride}
        helpText={<FormattedMessage id="settings.sandbox_issues.override_admins.helpText" />}
        label={
          <Text>
            <FormattedMessage
              id={
                isStandardMode
                  ? 'settings.sandbox_issues.override_admins.label.standard'
                  : 'settings.sandbox_issues.override_admins.label.mqr'
              }
            />
          </Text>
        }
        onCheck={onOverrideChange}
      />
    </>
  );
}
